<div *ngIf="listItems.length > 0">
    <app-custom-item-wish-list *ngFor="let item of listItems" [product]="item"
    (listChanges)="changeOfList()" ></app-custom-item-wish-list>
</div>
<div *ngIf="listItems.length == 0">
    <p>No tiene items en el carrito de compras, lo invitamos a ver nuestro catalogó.</p>
</div>
